import React from 'react';

import AvatarGroup from '@atlaskit/avatar-group';

export type TeamMemberAvatar = {
	accountId: string;
	name: string;
	picture?: string | null;
};

type TeamMembersAvatarGroupProps = {
	members: TeamMemberAvatar[];
};

const MAX_AVATAR_DISPLAY_COUNT = 5;

export const TeamMembersAvatarGroup = ({
	members,
}: TeamMembersAvatarGroupProps): React.JSX.Element | null => {
	if (members.length === 0) {
		return null;
	}

	return (
		<AvatarGroup
			size="small"
			appearance="stack"
			data={members.map((member) => ({
				key: member.accountId,
				name: member.name,
				src: member.picture ?? undefined,
			}))}
			overrides={
				members.length > MAX_AVATAR_DISPLAY_COUNT
					? {
							MoreIndicator: {
								render: (Component, props) => (
									<Component {...props} count={members.length - MAX_AVATAR_DISPLAY_COUNT + 1} />
								),
							},
						}
					: undefined
			}
		/>
	);
};
